import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/scss/global/index.scss';

import { BrowserRouter } from 'react-router-dom';
const container = document.getElementById('root');
    
ReactDOM.render(<BrowserRouter> <App /> </BrowserRouter>, container);
